<div class="container sms008">
  <!-- ヘッダーエリア -->
  <app-header></app-header>

  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">
        <div [formGroup]="smsForm">

          <!-- 賃料 -->
          <div class="kingaku-area">
            <div>
              <mat-label class="message" [style]="'font-size:20px;'">{{lblYatinTotal}}</mat-label>
              <br>
              <mat-label class="message" [style]="'font-size:14px;'">{{lblShutokuDate}}</mat-label>
            </div>
          </div>

          <!-- 物件名 -->
          <div class="bukken-area">
            <div>
              <mat-label class="message">{{lblBldgName}}</mat-label>
            </div>
          </div>

          <!-- 明細 -->
          <div>
            <fieldset class="grid-frame">

              <!-- yyyy年mm月元金 -->
              <div class="detail-row">
                <mat-label class="detail-itemMei">{{lblGankin[0]}}</mat-label>
                <mat-label class="detail-itemGaku">{{lblGankin[1]}}</mat-label>
              </div>
              <div class="item-line detail-line"></div>

              <!-- 保証委託料・支払手数料 -->
              <div class="detail-row">
                <mat-label class="detail-itemMei">{{lblHoshouItakuryou[0]}}</mat-label>
                <mat-label class="detail-itemGaku">{{lblHoshouItakuryou[1]}}</mat-label>
              </div>
              <div class="item-line detail-line"></div>

              <!-- 収納手数料・決済サービス -->
              <div class="detail-row">
                <mat-label class="detail-itemMei">{{lblShunouTesuryo[0]}}</mat-label>
                <mat-label class="detail-itemGaku">{{lblShunouTesuryo[1]}}</mat-label>
              </div>
              <div class="item-line detail-line"></div>

              <!-- 包括費用 -->
              <div class="detail-row">
                <mat-label class="detail-itemMei">{{lblHoukatuHiyo[0]}}</mat-label>
                <mat-label class="detail-itemGaku">{{lblHoukatuHiyo[1]}}</mat-label>
              </div>
              <div class="item-line detail-line"></div>

              <!-- 少額短期保険 -->
              <div class="detail-row">
                <mat-label class="detail-itemMei">{{lblShotanHokenryo[0]}}</mat-label>
                <mat-label class="detail-itemGaku">{{lblShotanHokenryo[1]}}</mat-label>
              </div>
              <div class="item-line detail-line"></div>

              <!-- 遅延損害金 -->
              <div class="detail-row">
                <mat-label class="detail-itemMei">{{lblTienSongaiKin[0]}}</mat-label>
                <mat-label class="detail-itemGaku">{{lblTienSongaiKin[1]}}</mat-label>
              </div>
              <div class="item-line detail-line"></div>

              <!-- 再請求手数料 -->
              <div class="detail-row">
                <mat-label class="detail-itemMei">{{lblSaiseikyuTesuryo[0]}}</mat-label>
                <mat-label class="detail-itemGaku">{{lblSaiseikyuTesuryo[1]}}</mat-label>
              </div>
              <div class="item-line detail-line"></div>

              <!-- 催告費用（書類作成代） -->
              <div class="detail-row">
                <mat-label class="detail-itemMei">{{lblSaikokuHiyoDocCost[0]}}</mat-label>
                <mat-label class="detail-itemGaku">{{lblSaikokuHiyoDocCost[1]}}</mat-label>
              </div>
              <div class="item-line detail-line"></div>

              <!-- 催告費用（郵送代） -->
              <div class="detail-row">
                <mat-label class="detail-itemMei">{{lblSaikokuHiyoYusoCost[0]}}</mat-label>
                <mat-label class="detail-itemGaku">{{lblSaikokuHiyoYusoCost[1]}}</mat-label>
              </div>
              <div class="item-line detail-line"></div>

              <div class="detail-row">
                <mat-label class="detail-itemMei">&nbsp;</mat-label>
                <mat-label class="detail-itemGaku">{{lblGoukeiGaku[1]}}</mat-label>
              </div>

            </fieldset>
          </div>
          <br>

          <!-- ボタン -->
          <div class="button-area">
            <button type="submit" mat-raised-button (click)="barcodeClick()"  tabindex="1">{{lblBtnBarcode}}</button>
            <button type="submit" mat-raised-button (click)="kozaInfoClick()" tabindex="2">{{lblBtnKozaInfo}}</button>
          </div>

        </div>
      </form>

    </div>
  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button (click)="backClick()" accesskey="q" tabindex="3">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
